export default __webpack_public_path__ + "static/media/roller1.7dd67ded.gif";